import React, { useEffect } from 'react';
import { Dialog, Notification } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { FaCheck } from 'react-icons/fa6';
import { IoClose } from 'react-icons/io5';
import { useLocation } from 'react-router-dom';

const statuses = {
  completed: {
    bgColor: '#dcfce7',
    color: 'teal',
    label: 'Extraction completed',
    icon: <FaCheck fontSize="16px" />
  },
  failed: {
    bgColor: '#ffe4e6',
    color: 'red',
    label: 'Extraction failed',
    icon: <IoClose fontSize="16px" />
  },
  'in progress': {
    bgColor: '#CDE0FF',
    label: (
      <>
        Background extraction in progress. <br />
        You can continue extracting data from other sheets.
      </>
    ),
    color: 'blue'
  }
};

export default function StatusTag({
  idPrefix,
  status,
  onCanceAutoExtract,
  hideCancelBtn,
  errorMessage
}) {
  const [opened, { toggle, close }] = useDisclosure(true);
  const rootId = idPrefix || 'data-extraction-status-tag';

  const location = useLocation();

  const onClose = () => {
    if (status === 'in progress') {
      onCanceAutoExtract();
      return;
    }
    close();
  };

  useEffect(() => {
    if (status !== 'completed') return;

    const timeoutId = setTimeout(onClose, 5000);

    return () => clearTimeout(timeoutId);
  }, [status]);

  const title =
    status === 'in progress' ? (
      location.pathname.includes('/funds') ? (
        <>
          The system is processing the uploaded files in the background. <br /> You can upload more
          files.
        </>
      ) : (
        statuses[status].label
      )
    ) : (
      statuses[status].label
    );

  return (
    <>
      <Dialog
        id={`${rootId}-dialog`}
        opened={status === 'in progress' ? true : opened}
        position={{
          bottom: 20,
          left: `calc(${window.innerWidth / 2}px - 150px)`
        }}
        size="md"
        radius="md"
        p="0"
        shadow="none"
      >
        <Notification
          id={`${rootId}-notification`}
          icon={statuses[status].icon}
          color={statuses[status].color}
          title={title}
          mt="md"
          loading={status === 'in progress'}
          withCloseButton={!hideCancelBtn}
          closeButtonProps={{ id: `${rootId}-close` }}
          onClose={onClose}
        >
          {status === 'failed' && errorMessage ? `: ${errorMessage}` : ''}
        </Notification>
      </Dialog>
    </>
  );
}
